import { useChannelsStore } from '@/store/useChannelsStore';
import { usePlayerStore } from '@/store/usePlayerStore';
import { ChannelGrid } from '@/components/channel/ChannelGrid';
import { PageHeader } from '@/components/common/PageHeader';
import { ChannelGridSkeleton } from '@/components/common/Skeleton';
import { Trophy } from 'lucide-react';

export function WorldCupPage() {
  const sportsChannels = useChannelsStore((s) => s.sportsChannels);
  const isLoading = useChannelsStore((s) => s.isLoadingInitial);
  const setCurrentChannel = usePlayerStore((s) => s.setCurrentChannel);
  const currentChannel = usePlayerStore((s) => s.currentChannel);

  if (isLoading) {
    return (
      <div className="space-y-4">
        <ChannelGridSkeleton count={6} />
      </div>
    );
  }

  const worldCup = sportsChannels.filter((c) => c.broadcasterGroup === 'world-cup');

  return (
    <div className="flex flex-col gap-6 h-full">
      <PageHeader
        icon={<Trophy className="w-7 h-7 text-accent" />}
        title="World Cup Broadcasters"
        subtitle={
          worldCup.length === 1
            ? '1 curated channel'
            : `${worldCup.length} curated channels`
        }
      />

      {/* Developer-only hint. Shown in `pnpm dev` so it's easy to find
          the data source, hidden in production so end users don't see
          implementation details. */}
      {import.meta.env.DEV && (
        <div className="text-xs text-text-muted bg-bg-elevated border border-border rounded-md p-3">
          Curated channels come from the <code className="text-accent">FEATURED_CHANNELS</code> constant
          in <code className="text-accent">src/lib/channels.ts</code>.
          Add tvg-ids under <code className="text-accent">worldCup</code> to include more broadcasters.
        </div>
      )}

      {worldCup.length === 0 ? (
        <div className="text-center py-12 text-text-muted">
          <Trophy className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p className="font-medium">No World Cup broadcasters curated yet</p>
          <p className="text-sm mt-1">
            Add tvg-ids to the FEATURED_CHANNELS constant in src/lib/channels.ts.
          </p>
        </div>
      ) : (
        <div className="flex-1 min-h-0">
          <ChannelGrid
            channels={worldCup}
            onChannelClick={setCurrentChannel}
            activeChannelId={currentChannel?.id}
            columns={4}
          />
        </div>
      )}
    </div>
  );
}
